import React, { Component } from "react";
import {
  commonDeleteBackendApi,
  getBackendCommonApi,
  updateCommon,
} from "redux/actions/Backend";
import {
  commonCreateApi,
  commonDeleteApi,
  commonPatchApi,
  commonUpdateApi,
  getCommonApi,
} from "redux/actions/common";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { bindActionCreators } from "redux";
import "./style.scss";

export class PettyCashClass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      transactionType: "Out", // 'In' or 'Out'
      selectedType: "",
      selectedStaff: "",
      amount: "",
      description: "",
      date: new Date().toISOString().split("T")[0],
      availableBalance: 0,
      transactions: [],
      expenseTypes: [],
      assetTypes: [],
      staffList: [],
      errors: {},
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchExpenseTypes();
    this.fetchStaff();
    this.fetchTransactions();
  }

  fetchExpenseTypes = () => {
    let { transactionType } = this.state;

    this.props
      .getCommonApi(`pettycash/?entry_type=${transactionType?.toUpperCase()}`)
      .then((res) => {
        const expenseTypes = res?.types;
        this.setState({
          expenseTypes,
          availableBalance: res?.available_petty_cash,
        });
      });
  };

  fetchStaff = () => {
    let { staffList, date } = this.state;
    this.props
      .getCommonApi(
        `appointment/Staffs/?Outlet=${this.props.tokenDetails?.logined_siteid}&date=${date}`
      )
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          for (let value of data) {
            staffList.push({ id: value.id, name: value.emp_name });
          }
          this.setState({ staffList });
        }
      });
  };

  fetchTransactions = () => {
  this.props.getCommonApi("pettycashtransaction/")
    .then((res) => {
      if (res && Array.isArray(res.data)) {
        this.setState({ transactions: res.data });
      }
    })
    .catch((err) => {
      console.error("Error loading transactions:", err);
    });
  };

  handleTransactionTypeChange = (e) => {
    this.setState({
      transactionType: e.target.value,
      expenseTypes: [],
      selectedType: "",
      errors: {},
    });
    this.props
      .getCommonApi(`pettycash/?entry_type=${e.target.value?.toUpperCase()}`)
      .then((res) => {
        const expenseTypes = res?.types;
        this.setState({
          expenseTypes,
          availableBalance: res?.available_petty_cash,
        });
      });
  };

  handleTypeChange = (e) => {
    this.setState({ selectedType: e.target.value });
  };

  handleStaffChange = (e) => {
    this.setState({ selectedStaff: e.target.value });
  };

  handleAmountChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      this.setState({ amount: value });
    }
  };

  handleDescriptionChange = (e) => {
    this.setState({ description: e.target.value });
  };

  handleDateChange = (e) => {
    this.setState({ date: e.target.value });
  };

  validateForm = () => {
    const errors = {};
    const {
      transactionType,
      selectedType,
      amount,
      description,
      availableBalance,
    } = this.state;

    if (!selectedType) {
      errors.type = "Please select a type";
    }

    if (!amount || parseFloat(amount) <= 0) {
      errors.amount = "Please enter a valid amount";
    }

    if (!description.trim()) {
      errors.description = "Please enter a description";
    }

    if (transactionType === "Out") {
      const newBalance = availableBalance - parseFloat(amount || 0);
      if (newBalance < 0) {
        errors.amount =
          "Insufficient petty cash balance. Transaction would result in negative balance.";
      }
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.isLoading) {
      return;
    }
    this.setState({
      isLoading: true,
    });
    // if (!this.validateForm()) {
    //   return;
    // }

    const {
      transactionType,
      selectedType,
      amount,
      description,
      date,
      availableBalance,
      staffList,
      transactions,
      selectedStaff,
    } = this.state;
    // const amountValue = parseFloat(amount);

    const newTransaction = {
      entry_type: transactionType?.toUpperCase(),
      type_id: selectedType,
      amount: amount,
      remark: description,
      date,
      staff: selectedStaff,
    };

    this.props
      .commonCreateApi("pettycash/", newTransaction)
      .then((res) => {
        this.handleReset();
        this.fetchExpenseTypes();
        this.fetchStaff();
        this.setState({
          isLoading: false,
        });
      })
      .catch((err) => {
        this.handleReset();
        this.setState({
          isLoading: false,
        });
      });
    console.log("Transaction saved:", newTransaction);
  };

  handleReset = () => {
    this.setState({
      selectedType: "",
      selectedStaff: "",
      amount: "",
      description: "",
      date: new Date().toISOString().split("T")[0],
      errors: {},
    });
  };

  render() {
    const {
      transactionType,
      selectedType,
      selectedStaff,
      amount,
      description,
      date,
      availableBalance,
      staffList,
      //   currentOutlet,
      expenseTypes,
      errors,
    } = this.state;

    return (
      <div className="petty-cash-container">
        <div className="petty-cash-header">
          <h1>Petty Cash Management</h1>
          {/* <div className="outlet-info">
            <span className="outlet-label">Outlet:</span>
            <span className="outlet-name">{currentOutlet}</span>
          </div> */}
        </div>

        <div className="petty-cash-card">
          <form onSubmit={this.handleSubmit} className="petty-cash-form">
            <div className="form-section">
              <label className="section-label">Transaction Type</label>
              <div className="radio-group">
                <label className="radio-label">
                  <input
                    type="radio"
                    name="transactionType"
                    value="Out"
                    checked={transactionType === "Out"}
                    onChange={this.handleTransactionTypeChange}
                  />
                  <span className="radio-text expense">Out (Expense)</span>
                </label>
                <label className="radio-label">
                  <input
                    type="radio"
                    name="transactionType"
                    value="In"
                    checked={transactionType === "In"}
                    onChange={this.handleTransactionTypeChange}
                  />
                  <span className="radio-text income">In (Add Petty Cash)</span>
                </label>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="type">Type </label>
                <select
                  id="type"
                  value={selectedType}
                  onChange={this.handleTypeChange}
                  className={errors.type ? "error" : ""}
                >
                  <option value="">Select Type</option>
                  {expenseTypes?.map((type) => (
                    <option key={type?.id} value={type?.id}>
                      {type?.name}
                    </option>
                  ))}
                </select>
                {errors.type && (
                  <span className="error-message">{errors.type}</span>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="type">Staff</label>
                <select
                  id="type"
                  value={selectedStaff}
                  onChange={this.handleStaffChange}
                >
                  <option value="">Select Staff</option>
                  {staffList?.map((type) => (
                    <option key={type?.id} value={type?.name}>
                      {type?.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="date">Date </label>
                <input
                  type="date"
                  id="date"
                  value={date}
                  onChange={this.handleDateChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="amount">Amount *</label>
                <input
                  type="text"
                  id="amount"
                  value={amount}
                  onChange={this.handleAmountChange}
                  placeholder="0.00"
                  className={errors.amount ? "error" : ""}
                />
                {errors.amount && (
                  <span className="error-message">{errors.amount}</span>
                )}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="description">Remark </label>
              <textarea
                id="description"
                value={description}
                onChange={this.handleDescriptionChange}
                placeholder="Enter remark"
                rows="3"
                className={errors.description ? "error" : ""}
              />
              {errors.description && (
                <span className="error-message">{errors.description}</span>
              )}
            </div>

            <div className="form-actions ">
              {/* <button
                type="button"
                onClick={this.handleReset}
                className="btn btn-secondary"
              >
                Reset
              </button> */}
              <div className="col-9"></div>
              <div className="col-3">
                <button type="submit" className="btn btn-primary">
                  Add
                </button>
              </div>
            </div>
          </form>

          <div className="balance-display">
            <div className="balance-card">
              <span className="balance-label">Available Petty Cash</span>
              <span
                className={`balance-amount ${
                  availableBalance < 1000 ? "low" : ""
                }`}
              >
                ${availableBalance.toFixed(2)}
              </span>
            </div>
          </div>

          <div className="transaction-table">
            <h2>Recent Transactions</h2>
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Category</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Staff</th>
                  <th>Remark</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {this.state.transactions.length > 0 ? (
                  this.state.transactions.map((tx, idx) => (
                    <tr key={idx}>
                      <td>{tx.date || "-"}</td>
                      <td>{tx.category || "-"}</td>
                      <td>{tx.entry_type || "-"}</td>
                      <td>${Number(tx.amount || 0).toFixed(2)}</td>
                      <td>{tx.staff || "-"}</td>
                      <td>{tx.remark || "-"}</td>
                      <td>${Number(tx.balance || 0).toFixed(2)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">No transactions found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedCart: state.common.selectedCart,
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // getCustomer,
      getCommonApi,
      commonDeleteApi,
      commonPatchApi,
      commonCreateApi,
      commonUpdateApi,
      updateCommon,
      getBackendCommonApi,
      commonDeleteBackendApi,
    },
    dispatch
  );
};

export const PettyCash = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(PettyCashClass)
);
